import '@/css/globals.css';

import { createGtm } from '@gtm-support/vue-gtm';
import * as Sentry from '@sentry/vue';
import mixpanel from 'mixpanel-browser';
import { createPinia } from 'pinia';
import { createRoot } from 'react-dom/client';
import { setVeauryOptions } from 'veaury';
import { createApp } from 'vue';
// @ts-expect-error missing types
import shortkey from 'vue-three-shortkey';
import App from '@/App.vue';
import router from '@/router';

// Configure Veaury to use React 18's createRoot API
setVeauryOptions({
  react: {
    createRoot,
  },
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(shortkey);
app.use(
  createGtm({
    id: 'GTM-MQ26N647',
    vueRouter: router,
  }),
);

const { host } = window.location;
if (host === 'app.sparklayer.io' || host === 'app.dev.sparklayer.io') {
  Sentry.init({
    app,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb?.data?.url?.includes('clarity.ms')) {
        return null;
      }
      return breadcrumb;
    },
    dsn: 'https://b2cd1b9778ed4f8abe25362246e2c35f@o932531.ingest.sentry.io/5881317',
    environment: host,
    ignoreErrors: [
      // Ignore network errors which are likely caused by user's unreliable
      // network connection
      'error loading dynamically imported module',
      'Failed to fetch dynamically imported module',
      'Load failed',
      'NetworkError',
      'Network Error',
      'Unable to preload CSS',

      // https://stackoverflow.com/a/50387233
      'ResizeObserver loop limit exceeded',

      'ResizeObserver loop completed with undelivered notifications.',
      'Request failed with status code 401',
      'Request failed with status code 419',
    ],
    integrations: [Sentry.browserTracingIntegration({ router })],
    // __SENTRY_RELEASE__ is statically replaced at build time by Vite
    // biome-ignore lint/correctness/noUndeclaredVariables: defined in build process
    release: __SENTRY_RELEASE__,
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
  });
}

if (host === 'app.sparklayer.io' || host === 'app.dev.sparklayer.io') {
  mixpanel.init('ab795b7a2dc0a7dd5e60bc733715efb5', { track_pageview: false });
}

app.mount('#app');
